import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import {Loader, Header, Button, Message} from 'semantic-ui-react';
import {Contexts} from 'componentLibrary';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {
  REQUEST_DETAILS_CHANGES_TYPES,
  STATUS_APPROVED,
} from 'app-ui-componentlibrary/dist/common/constants';
import {
  PREVIOUS_REQUEST_DETAILS,
  DEFAULT_CONFIG,
  FUNDING_STREAM_NAME,
  MODES,
  MODE_NAMES,
} from 'common/requestDetails/constants.js';
import {
  getChildrenMapping,
  filterConfig,
  getValidPositions,
  calculateFederalTotal,
  filterPositionsForFundingStream,
} from 'common/requestDetails/utils';
import {
  calculateChildrenActualAllowedTotalByMode,
  calculateChildrenActualTotalByMode,
  calculateChildrenTotalByMode,
  calculateBudget,
  calculatePeriod,
  deriveAppShareRates,
} from 'common/requestDetails/utils';
import {
  filterEntities,
  safeAddReduce,
  scrollIt,
  findOffsetTopById,
  safeAddNoFixed,
  generateTimeId,
} from 'common/utils';
import ItemDispatch from 'go/components/modules/requestDetails/v3/ItemDispatch';
import AddItemModal from 'go/components/modules/requestDetails/v3/AddItemModal';
import produce from 'immer';
import moment from 'moment';
import {GrandHeaderCard} from 'go/components/modules/requestDetails/v3/renderers/grandHeaderCard';
const {RequestDetailsContext, EligibleItemsContext} = Contexts;

const EMPTY_REQUEST_DETAILS = [];

export const sortFundingStreams = (streams, streamsConfig) => {
  const orderedTypes = _.map(
    streamsConfig,
    (streamConfig) => streamConfig.fundingStreamType
  );
  let sorted = [];
  _.forEach(orderedTypes, (type) => {
    const currStream = _.find(streams, (stream) => stream.fundingStreamType === type);
    if (currStream) {
      sorted.push(currStream);
    }
  });

  return sorted;
};

export class RequestDetailsController extends React.Component {
  state = {
    savingDataInitially: false,
    waitingToScroll: '',
    addedActivityId: undefined,
    periodTerm: undefined,
  };

  static defaultProps = {
    mode: MODES.REVIEW,
  };

  componentDidUpdate(prevProps) {
    const {data, dataLoading, editable, mode} = this.props;
    const {savingDataInitially} = this.state;
    const existingRequestDetails = _.get(this.props, PREVIOUS_REQUEST_DETAILS);

    /** TODO Can be removed and functionality replaced with config-based reducers block **/
    const prevappChar = _.get(prevProps, 'applicantCharacteristics');
    const appChar = _.get(this.props, 'applicantCharacteristics');

    if (
      mode === MODES.APPLICATION &&
      prevappChar !== undefined &&
      (!_.isEqual(prevappChar.type, appChar.type) ||
        !_.isEqual(prevappChar.regionalApplicant, appChar.regionalApplicant) ||
        !_.isEqual(prevappChar.isMicroGrant, appChar.isMicroGrant))
    ) {
      let data = [];
      this.saveToStore(data);
    }
    /** END TODO **/

    // prepopulates the data from the existing request details
    if (
      !savingDataInitially &&
      data === undefined &&
      dataLoading === false &&
      editable &&
      existingRequestDetails !== undefined
    ) {
      this.setState(
        {
          savingDataInitially: true,
        },
        () => this.saveToStore(existingRequestDetails)
      );
    } else if (data !== undefined && savingDataInitially) {
      this.setState({
        savingDataInitially: false,
      });
    } else if (
      !savingDataInitially &&
      data === undefined &&
      dataLoading === false &&
      editable &&
      mode === MODES.APPLICATION
    ) {
      this.setState(
        {
          savingDataInitially: true,
        },
        () => this.saveToStore(EMPTY_REQUEST_DETAILS)
      );
    } else if (
      this.state.waitingToScroll != '' &&
      document.getElementById(this.state.waitingToScroll) != null
    ) {
      const scrollId = this.state.waitingToScroll;
      this.setState(
        {
          waitingToScroll: '',
        },
        () => {
          scrollIt(
            document.getElementById('root'),
            findOffsetTopById(scrollId) - 50,
            250
          );
        }
      );
    }
  }

  getEmptyCard = () => ({
    changes: {
      type: REQUEST_DETAILS_CHANGES_TYPES.NEWLY_CREATED,
    },
  });

  getDataToChange = () => {
    return _.cloneDeep(this.props.data);
  };

  getFieldNameToBlur = (pathList, fieldName) => {
    const {validationId} = this.props;
    return validationId && fieldName ? `${validationId}.${pathList}.${fieldName}` : false;
  };

  addItem = (pathList, lineItem, id) => {
    this.setState(
      {
        waitingToScroll: `item-${_.join(_.split(id ? id : pathList, '.'), '-')}`,
        addedActivityId: id ? id : pathList,
      },
      () => this.saveItem(pathList, lineItem)
    );
  };

  deleteItem = (pathList) => {
    let data = this.getDataToChange();
    _.unset(data, pathList);
    _.forEach(data, (stream, index) =>
      _.isEmpty(stream.children) ? (data[index] = null) : null
    );
    data = _.filter(data, (x) => !!x);
    this.saveToStore(data);
  };

  saveItem = (pathList, lineItem, fieldName) => {
    let data = this.getDataToChange();
    _.setWith(data, pathList, lineItem, Object);
    const fieldNameToBlur = this.getFieldNameToBlur(pathList, fieldName);
    this.saveToStore(data, fieldNameToBlur);
  };

  calculateTotal = (updatedData) => {
    const {
      mode,
      fundingOpportunityStreams,
      staffingStreamType,
      paymentPeriod,
      pastPayments,
      entityId,
      periodOfPerformance,
      grantBudgetShareFedRate,
      turnOffvalidationLimits,
      editable,
      roster,
    } = this.props;

    const staffingBundledDataStream = _.find(
      updatedData,
      (stream) => stream.fundingStreamType === staffingStreamType
    );

    if (staffingBundledDataStream !== undefined && mode === MODES.PAYMENT_REQUEST) {
      if (editable) {
        const positionsValid = getValidPositions(
          roster,
          paymentPeriod.startDate,
          paymentPeriod.endDate
        );

        let approvedPayments = _.chain(
          filterEntities(pastPayments, [entityId], [STATUS_APPROVED])
        )
          .map((payment) => {
            const stream = _.find(
              _.get(payment, 'payload.paymentStreams'),
              (stream) => stream.fundingStreamType === staffingStreamType
            );
            return {
              ...stream,
              request: _.get(payment, 'payload.request', {}),
              entityNumber: _.get(payment, 'entityNumber'),
              manualPayment: _.get(payment, 'manualPayment', false),
              paymentAdjustment: _.get(payment, 'paymentAdjustment', 0),
            };
          })
          .value();

        let sumPastPaymentAmounts = _.chain(
          filterEntities(pastPayments, [entityId], [STATUS_APPROVED])
        )
          .reduce((total, p) => {
            const paymentEndDate = moment(_.get(p, 'payload.request.endDate'));

            if (
              paymentEndDate &&
              paymentEndDate.isBefore(moment(paymentPeriod.endDate))
            ) {
              return safeAddNoFixed(total, _.get(p, ['payload', 'amount'], 0));
            } else {
              return total;
            }
          }, 0)
          .value();

        const federalTotalInfo = calculateFederalTotal(positionsValid, {
          staffingBundledDataStream,
          endDate: paymentPeriod.endDate,
          periodOfPerformance,
          approvedPayments,
          grantBudgetShareFedRate,
          sumPastPaymentAmounts: sumPastPaymentAmounts,
          turnOffvalidationLimits,
        });
        return {
          ...federalTotalInfo,
          isPaymentHiring: true,
        };
      } else {
        return {
          grandTotal: _.get(this.props, 'amount', 0),
          isPaymentHiring: true,
        };
      }
    } else {
      const grandTotal = safeAddReduce(
        _.map(updatedData, (stream) => {
          return calculateChildrenTotalByMode(stream.children, mode);
        }),
        0
      );
      return {
        grandTotal,
      };
    }
  };

  isCostShareApproved = () => {
    const {waiverRequested, costShareInformation} = this.props;
    if (costShareInformation) {
      const {waiverDetermination} = costShareInformation;

      return (
        (waiverRequested === true || waiverRequested === 'Yes') &&
        waiverDetermination === 'Approved'
      );
    }
    return false;
  };

  saveToStore = (updatedData, fieldName) => {
    const {
      entityType,
      entityDataPath,
      entityTypeReduxPath,
      saveTotalDataPath,
      saveActualTotalDataPath,
      saveFedShareDataPath,
      saveActualFedShareDataPath,
      saveAppShareDataPath,
      saveActualAppShareDataPath,
      saveActualAllowedTotalDataPath,
      saveActualAllowedFedShareDataPath,
      saveActualAllowedAppShareDataPath,
      fedShareRate,
      extraProps,
      mode,
      handlePostSave,
      budgetCalculationMode,
      costShare,
      previousGrantBudget,
    } = this.props;
    const {periodTerm} = this.state;
    let appShareRate = this.props.appShareRate;
    const isCostShareApproved = this.isCostShareApproved();

    if (fedShareRate && !appShareRate) {
      appShareRate = deriveAppShareRates(fedShareRate, periodTerm);
    }

    if (mode === MODES.APPLICATION && saveTotalDataPath === undefined) {
      this.props.saveEntityData(entityDataPath, entityType, updatedData, fieldName);
    } else {
      const foTotals = this.calculateTotal(updatedData).grandTotal;

      const foActualTotals =
        mode === MODES.CLOSEOUT_REPORT
          ? safeAddReduce(
              _.map(updatedData, (stream) => {
                return calculateChildrenActualTotalByMode(
                  stream.children,
                  this.props.mode
                );
              }),
              0
            )
          : undefined;

      const foActualAllowedTotals =
        mode === MODES.CLOSEOUT_REPORT_REVIEW
          ? safeAddReduce(
              _.map(updatedData, (stream) => {
                return calculateChildrenActualAllowedTotalByMode(
                  stream.children,
                  this.props.mode
                );
              }),
              0
            )
          : undefined;

      let newExtraProps = {};

      if (entityTypeReduxPath) {
        newExtraProps = {...extraProps, index: this.props.entityDataPathIndx};
      }

      let fedShare,
        appShare,
        fedActualShare,
        appActualShare,
        fedActualAllowedShare,
        appActualAllowedShare;

      if (
        fedShareRate &&
        _.isFinite(parseFloat(foActualAllowedTotals)) &&
        _.isFinite(parseFloat(fedShareRate))
      ) {
        let actualAllowedBudget = calculateBudget(
          budgetCalculationMode,
          periodTerm,
          foActualAllowedTotals,
          fedShareRate,
          appShareRate,
          mode,
          updatedData,
          isCostShareApproved,
          previousGrantBudget
        );
        fedActualAllowedShare = actualAllowedBudget.fedShare;
        appActualAllowedShare = actualAllowedBudget.appShare;
      } else if (
        _.isFinite(parseFloat(foActualTotals)) &&
        fedShareRate &&
        _.isFinite(parseFloat(foTotals)) &&
        _.isFinite(parseFloat(fedShareRate))
      ) {
        let actualBudget = calculateBudget(
          budgetCalculationMode,
          periodTerm,
          foActualTotals,
          fedShareRate,
          appShareRate,
          mode,
          updatedData,
          isCostShareApproved,
          previousGrantBudget
        );
        fedActualShare = actualBudget.fedShare;
        appActualShare = actualBudget.appShare;
      } else if (
        foTotals &&
        fedShareRate &&
        _.isFinite(parseFloat(foTotals)) &&
        _.isFinite(parseFloat(fedShareRate))
      ) {
        let budget = calculateBudget(
          budgetCalculationMode,
          periodTerm,
          foTotals,
          fedShareRate,
          appShareRate,
          mode,
          updatedData
        );
        fedShare = budget.fedShare;
        appShare = budget.appShare;
      }

      if (fedActualAllowedShare && appActualAllowedShare) {
        if (costShare && _.isEqual(costShare.alternateCostShare, 'Yes')) {
          this.props.saveManyEntityData(
            [entityDataPath, saveActualAllowedTotalDataPath],
            entityType,
            [updatedData, foActualAllowedTotals],
            fieldName,
            newExtraProps,
            entityTypeReduxPath
          );
        } else {
          this.props.saveManyEntityData(
            [
              entityDataPath,
              saveActualAllowedTotalDataPath,
              saveActualAllowedFedShareDataPath,
              saveActualAllowedAppShareDataPath,
            ],
            entityType,
            [
              updatedData,
              foActualAllowedTotals,
              fedActualAllowedShare,
              appActualAllowedShare,
            ],
            fieldName,
            newExtraProps,
            entityTypeReduxPath
          );
        }
      } else if (fedActualShare && appActualShare) {
        this.props.saveManyEntityData(
          [
            entityDataPath,
            saveActualTotalDataPath,
            saveActualFedShareDataPath,
            saveActualAppShareDataPath,
          ],
          entityType,
          [updatedData, foActualTotals, fedActualShare, appActualShare],
          fieldName,
          newExtraProps,
          entityTypeReduxPath
        );
      } else if (fedShare && appShare) {
        this.props.saveManyEntityData(
          [entityDataPath, saveTotalDataPath, saveFedShareDataPath, saveAppShareDataPath],
          entityType,
          [updatedData, foTotals, fedShare, appShare],
          fieldName,
          newExtraProps,
          entityTypeReduxPath
        );
      } else {
        this.props.saveManyEntityData(
          [entityDataPath, saveTotalDataPath],
          entityType,
          [updatedData, foTotals],
          fieldName,
          newExtraProps,
          entityTypeReduxPath
        );
      }

      if (entityTypeReduxPath) {
        handlePostSave(entityTypeReduxPath);
      }
    }
  };

  setPeriodTerm = (itemEligibilityConfig) => {
    if (!this.state.periodTerm) {
      const periodTerm = calculatePeriod(itemEligibilityConfig);
      this.setState({
        periodTerm: periodTerm,
      });
    }
  };

  render() {
    const {
      editable,

      data,
      id,
      dependencies,
      headerSize,
      grantId,
      subGrantId,
      moreDetailsURLType,
      moreDetailsURLId,
      noHeaderName,
      headerLink,
      entityId,
      mode,
      paymentPeriod,
      moreDetails,
      entityDataPath,
      guidance,
      validationErrors,
      validationDirtyMap,
      activityOrder,
      itemType,
      disableFields,
      changeLabel,
      justificationLabel,
      modeName,
      entityType,
      additionalQuestionsEntityType,
      headerContents,
      displayFields,
      costSectionHeader,
      fundingOpportunityStreams,
      periodOfPerformance,
      staffingStreamType,
      grantBudgetShareFedRate,
      turnOffvalidationLimits,
      entityDataPathIndx,
      showAdditionalQuestions,
      customizations,
      currentlyCollaborating,
    } = this.props;
    let rdContext;
    if (mode === MODES.PAYMENT_REQUEST) {
      let pastPayments = {..._.get(this.props, 'pastPayments', {})};
      delete pastPayments.loading;
      pastPayments = _.values(pastPayments);

      let otherPayments = filterEntities(pastPayments, [entityId], [STATUS_APPROVED]);

      let roster = _.cloneDeep(_.get(this.props, 'roster', []));
      _.forEach(roster, (pos, index) => {
        pos.positionDisplayId = index;
        let positionId = pos.positionId;
        _.forEach(_.get(pos, 'employees'), (employee) => {
          _.set(employee, 'positionId', positionId);
        });
      });

      rdContext = {
        mode,
        otherPayments,
        roster,
        paymentPeriod,
        fundingOpportunityStreams,
        periodOfPerformance,
        staffingStreamType,
        grantBudgetShareFedRate,
        totalsInfo: this.calculateTotal(data),
        turnOffvalidationLimits,
        customizations,
      };
    } else {
      rdContext = {
        mode,
        entityDataPath: entityDataPath,
        showAdditionalQuestions,
        entityType,
        customizations,
        saveItem: this.saveItem,
      };
    }

    let grandTotal = safeAddReduce(
      _.map(data, (stream) => {
        return calculateChildrenTotalByMode(stream.children, this.props.mode);
      }),
      0
    );

    let actualGrandTotal =
      mode === MODES.CLOSEOUT_REPORT
        ? (actualGrandTotal = safeAddReduce(
            _.map(data, (stream) => {
              return calculateChildrenActualTotalByMode(stream.children, this.props.mode);
            }),
            0
          ))
        : undefined;

    let actualAllowedGrandTotal =
      mode === MODES.CLOSEOUT_REPORT_REVIEW
        ? (actualAllowedGrandTotal = safeAddReduce(
            _.map(data, (stream) => {
              return calculateChildrenActualAllowedTotalByMode(
                stream.children,
                this.props.mode
              );
            }),
            0
          ))
        : undefined;
    if (this.props.saveTotalDataPath && !this.props.skipOverrideTotal) {
      grandTotal = _.get(this.props, 'totalDataValue');
    }

    const totalsInfo = _.get(rdContext, 'totalsInfo');

    const requiresApplication =
      _.findIndex(dependencies, (dep) => _.get(dep, PREVIOUS_REQUEST_DETAILS)) > -1;
    let previousRequestDetails = this.props[PREVIOUS_REQUEST_DETAILS];

    const detailsType = moreDetailsURLType ? moreDetailsURLType : 'grant';
    const detailsId = moreDetailsURLId
      ? entityType === 'subAmendmentRecommendation' ||
        entityType === 'subAwardRecommendation'
        ? modeName
        : moreDetailsURLId
      : grantId;
    const moreDetailsURL =
      detailsType === 'grant'
        ? `/${detailsType}/${detailsId}/application?scrollTo=${id}`
        : `/${detailsType}/${detailsId}`;
    return (
      <React.Fragment>
        <RequestDetailsContext.Provider value={rdContext}>
          <RequestDetailsDisplay
            editable={editable}
            fundingStreams={data}
            id={id}
            grantId={grantId}
            subGrantId={subGrantId}
            moreDetailsURL={moreDetailsURL}
            headerSize={headerSize}
            noHeaderName={noHeaderName}
            headerLink={headerLink}
            mode={mode}
            moreDetails={moreDetails}
            additionalQuestionsEntityType={additionalQuestionsEntityType}
            entityDataPath={entityDataPath}
            guidance={guidance}
            requiresApplication={requiresApplication}
            previousRequestDetails={previousRequestDetails}
            validationErrors={validationErrors}
            validationDirtyMap={validationDirtyMap}
            addItem={this.addItem}
            saveItem={this.saveItem}
            setPeriodTerm={this.setPeriodTerm}
            deleteItem={this.deleteItem}
            activityOrder={activityOrder}
            grandTotal={grandTotal}
            actualGrandTotal={actualGrandTotal}
            actualAllowedGrandTotal={actualAllowedGrandTotal}
            addedActivityId={this.state.addedActivityId}
            itemType={itemType}
            data={data}
            disableFields={disableFields}
            changeLabel={changeLabel}
            justificationLabel={justificationLabel}
            modeName={modeName}
            headerContents={headerContents}
            displayFields={displayFields}
            costSectionHeader={costSectionHeader}
            staffingStreamType={staffingStreamType}
            totalsInfo={totalsInfo}
            entityDataPathIndx={entityDataPathIndx}
            currentlyCollaborating={currentlyCollaborating}
          />
        </RequestDetailsContext.Provider>
      </React.Fragment>
    );
  }
}

export class RequestDetailsDisplay extends React.Component {
  static contextType = EligibleItemsContext;

  render() {
    const {
      editable,
      fundingStreams,
      id,
      headerSize,
      noHeaderName,
      headerLink,
      mode,
      moreDetails,
      additionalQuestionsEntityType,
      entityDataPath,
      guidance,
      addItem,
      deleteItem,
      saveItem,
      setPeriodTerm,
      requiresApplication,
      previousRequestDetails,
      validationErrors,
      validationDirtyMap,
      activityOrder,
      grandTotal,
      actualGrandTotal,
      actualAllowedGrandTotal,
      addedActivityId,
      itemType,
      data,
      moreDetailsURL,
      disableFields,
      changeLabel,
      justificationLabel,
      modeName,
      headerContents,
      displayFields,
      costSectionHeader,
      staffingStreamType,
      totalsInfo,
      entityDataPathIndx,
      currentlyCollaborating,
    } = this.props;

    const eligibilityConfig = _.get(this.context, 'eligibilityConfig', {});
    const sortedStreams = sortFundingStreams(
      fundingStreams,
      eligibilityConfig.fundingStream
    );

    const errorResults = _.get(validationErrors, `0.results.0.${entityDataPath}`);
    const validationDirty = _.get(validationDirtyMap, 'dirty');
    const headerName = modeName ? modeName : _.get(MODE_NAMES, mode);
    const loadedApplicationDataIfNeeded =
      fundingStreams !== undefined && (!requiresApplication || previousRequestDetails);

    const isLoaded = loadedApplicationDataIfNeeded;
    if (!isLoaded && editable) {
      return (
        <Loader inline="centered" active>
          Loading...
        </Loader>
      );
    }

    return (
      <React.Fragment>
        <RequestDetailsHeader
          id={id}
          editable={editable}
          eligibilityConfig={eligibilityConfig}
          fundingStreams={fundingStreams}
          isLoaded={isLoaded}
          addItem={addItem}
          headerSize={headerSize}
          name={headerName}
          guidance={guidance}
          noHeaderName={noHeaderName}
          headerLink={headerLink}
          activityOrder={activityOrder}
          grandTotal={grandTotal}
          actualGrandTotal={actualGrandTotal}
          actualAllowedGrandTotal={actualAllowedGrandTotal}
          itemType={itemType}
          headerContents={headerContents}
          entityDataPathIndx={entityDataPathIndx}
          displayFields={displayFields}
          mode={mode}
          totalsInfo={totalsInfo}
          currentlyCollaborating={currentlyCollaborating}
        />
        <br />
        <div className="padding-bottom--double" style={{display: 'grid'}}>
          {_.map(sortedStreams, (stream, ind) => {
            const fundingStreamType = stream.fundingStreamType;
            const index = _.findIndex(
              fundingStreams,
              (currStream) => currStream.fundingStreamType === fundingStreamType
            );
            const fundingStreamName = fundingStreamType;
            const fundingStreamEligibilityConfig = _.find(
              eligibilityConfig.fundingStream,
              (streamConfig) => streamConfig.fundingStreamType === fundingStreamType
            );
            const fundingStreamItems = _.get(fundingStreamEligibilityConfig, 'items');
            const fundingStreamLabels = _.get(
              fundingStreamEligibilityConfig,
              'labels',
              {}
            );
            const fundingStreamLabel = _.get(
              fundingStreamLabels,
              'fundingStream',
              'Funding stream'
            );
            const streamMoreDetails = _.find(
              moreDetails,
              (detail) => detail.fundingStreamType === fundingStreamType
            );

            let knownActivities = _.size(activityOrder);
            let sortedChildren = [];
            _.forEach(_.get(stream, 'children'), (firstTierItem, firstTierKey) => {
              const pathToStream = [index, 'children', firstTierKey];
              const itemCode = firstTierItem.itemCode;
              let itemEligibilityConfig = _.find(
                fundingStreamItems,
                (itemConfig) => itemConfig.itemCode === itemCode
              );

              itemEligibilityConfig = {
                ...fundingStreamEligibilityConfig,
                ...DEFAULT_CONFIG,
                ...itemEligibilityConfig,
              };

              const itemMoreDetails = _.find(
                _.get(streamMoreDetails, 'children'),
                (moreDetailSection) => itemCode === moreDetailSection.itemCode
              );

              setPeriodTerm(itemEligibilityConfig);

              const itemOptions = {
                editable: !!editable,
                mode: mode,
                sourcePath: `${index}.children`,
                addItem: addItem,
                deleteItem: deleteItem,
                saveItem: saveItem,
                itemConfig: itemEligibilityConfig,
                validationErrors: _.get(errorResults, pathToStream),
                validationDirtyMap: _.get(validationDirty, pathToStream),
                item: firstTierItem,
                tierKey: firstTierKey,
                originalItem: _.get(previousRequestDetails, pathToStream),
                moreDetailsURL: moreDetailsURL,
                addedActivityId: addedActivityId,
                data: data,
                disableFields: disableFields,
                changeLabel: changeLabel,
                justificationLabel: justificationLabel,
                displayFields: displayFields,
                costSectionHeader: costSectionHeader,
                staffingStreamType: staffingStreamType,
                additionalQuestionsEntityType: additionalQuestionsEntityType,
              };
              let actIndex = _.findIndex(
                activityOrder,
                (act) => _.get(itemEligibilityConfig, 'itemCode') === act
              );
              actIndex = actIndex > -1 ? actIndex : knownActivities++;

              if (!sortedChildren[actIndex]) sortedChildren[actIndex] = [];
              sortedChildren[actIndex].push(
                <ItemDispatch {...itemOptions} key={firstTierKey} />
              );
            });
            const fundingStreamChildren = _.flatMap(
              _.filter(sortedChildren, (x) => x != null)
            );
            return (
              <React.Fragment key={fundingStreamType}>
                {_.size(fundingStreamChildren) > 0 && (
                  <h3 className="apph3 margin-bottom10 margin-top30 underline-seg blue">
                    {fundingStreamLabel}:{' '}
                    {_.get(FUNDING_STREAM_NAME, fundingStreamName, '')}
                  </h3>
                )}
                {fundingStreamChildren}
              </React.Fragment>
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}

export const findStreamByItemCode = (itemCode, childrenConfigs) => {
  return _.get(
    _.find(childrenConfigs, (config) => config.itemCode === itemCode),
    'fundingStreamType'
  );
};

export const indexOfStream = (fundingStreamType, fundingStreams) => {
  const ind = _.findIndex(
    fundingStreams,
    (stream) => stream.fundingStreamType === fundingStreamType
  );
  return ind !== -1 ? ind : _.size(fundingStreams); // add to array
};

export const getStreamConfigItems = (stream) => {
  return _.map(stream.items, (item) => ({
    ...stream,
    ...DEFAULT_CONFIG,
    ...item,
  }));
};

export class RequestDetailsHeader extends React.Component {
  state = {
    openModal: false,
  };

  saveItemFromModal = (newKey, item, filteredChildrenConfig) => {
    const {fundingStreams, addItem, currentlyCollaborating} = this.props;
    const fundingStreamType = findStreamByItemCode(item.itemCode, filteredChildrenConfig);
    const existingFundingStreamIndex = indexOfStream(fundingStreamType, fundingStreams);
    const fundingStream = produce(
      _.get(fundingStreams, existingFundingStreamIndex, {
        fundingStreamType,
        ...(currentlyCollaborating && {id: fundingStreamType}),
      }),
      (draft) => {
        _.set(draft, 'children.' + newKey, item);
      }
    );

    const activityId = existingFundingStreamIndex + '.children.' + newKey;
    addItem(existingFundingStreamIndex, fundingStream, activityId);
  };

  render() {
    const {
      editable,
      eligibilityConfig,
      fundingStreams,
      id,
      isLoaded,
      mode,
      name,
      guidance,
      noHeaderName,
      headerLink,
      activityOrder,
      grandTotal,
      actualGrandTotal,
      actualAllowedGrandTotal,
      itemType,
      headerContents,
      displayFields,
      totalsInfo,
      entityDataPathIndx,
    } = this.props;
    const allowAdd = mode !== MODES.CLOSEOUT_REPORT_REVIEW;
    const eligibleStreams = eligibilityConfig.fundingStream;
    const addingToName = 'Request Details';
    /* data analysis for add item configuration */
    const topLevelItemCodes = _.flatMap(
      _.map(fundingStreams, (stream, index) =>
        _.map(stream.children, (item) => ({
          itemCode: item.itemCode,
          fundingStreamType: stream.fundingStreamType,
          fundingStreamIndex: index,
        }))
      )
    );

    const topLevelItemCodeCounts = {};
    _.forEach(topLevelItemCodes, (code) =>
      _.set(
        topLevelItemCodeCounts,
        code.itemCode,
        _.get(topLevelItemCodeCounts, code.itemCode, 0) + 1
      )
    );

    const ineligibleFundingStreams = _.map(
      _.filter(eligibleStreams, (stream) => !stream.ineligible),
      (stream) => stream.fundingStreamType
    );

    const childrenConfigs = _.flatMap(_.map(eligibleStreams, getStreamConfigItems));
    const filteredChildrenConfig = _.filter(
      filterConfig(childrenConfigs, topLevelItemCodeCounts),
      (config) => _.includes(ineligibleFundingStreams, config.fundingStreamType)
    );

    const hasEligibleChildren = _.size(filteredChildrenConfig) > 0;

    const unfilteredOptions = getChildrenMapping(filteredChildrenConfig);
    let sortedOptions = [];
    let knownActivities = _.size(activityOrder);
    _.forEach(unfilteredOptions, (option) => {
      let index = _.findIndex(activityOrder, (act) => option.key === act.toString());
      index = index > -1 ? index : knownActivities++;
      sortedOptions[index] = option;
    });
    const childrenItemCodeOptions = _.filter(sortedOptions, (opt) => opt != null);

    return (
      <React.Fragment>
        {isLoaded &&
          editable &&
          hasEligibleChildren &&
          !_.get(totalsInfo, 'isPaymentHiring') && (
            <AddItemModal
              active={this.state.openModal}
              saveItem={(newKey, item) =>
                this.saveItemFromModal(newKey, item, filteredChildrenConfig)
              }
              cancelAction={() => this.setState({openModal: false})}
              itemCodeOptions={childrenItemCodeOptions}
              addingToName={addingToName}
              eligibleChildren={filteredChildrenConfig}
              existingCodes={{}}
              displayFields={displayFields}
              mode={mode}
            />
          )}
        <GrandHeaderCard
          allowAdd={allowAdd}
          itemType={itemType}
          grandTotal={grandTotal}
          actualGrandTotal={actualGrandTotal}
          actualAllowedGrandTotal={actualAllowedGrandTotal}
          noHeaderName={noHeaderName}
          headerLink={headerLink}
          isLoaded={isLoaded}
          editable={editable}
          hasEligibleChildren={hasEligibleChildren}
          id={id}
          name={name}
          guidance={guidance}
          showActivityModal={() => this.setState({openModal: true})}
          headerContents={headerContents}
          entityDataPathIndx={entityDataPathIndx}
          mode={mode}
          totalsInfo={totalsInfo}
        />
      </React.Fragment>
    );
  }
}
export const mapStateToProps = (state) => ({
  currentlyCollaborating: !!_.get(state, 'dynamicComponent.collaboration.roomList', ''),
});

export default connect(mapStateToProps)(connectDynamic(RequestDetailsController));
